<template>
    <div>
        <ui-modal v-ref:loading-modal>
            Carregando...
        </ui-modal>
        <ui-modal v-ref:modal :width="650   ">
            <div slot="header" v-if="task">
                {{ task.humanName }}
            </div>
            <div v-if="task">
                <div style="padding: 40px 40px 20px 40px">
                    <div v-if="task.status === 'DONE'">
                        <div style="text-align: center; margin-bottom: 10px">
                            <i class="fa fa-check-circle" :class="task.humanStatus.class" style="font-size: 80px"></i>
                        </div>
                        <div style="text-align: center">
                            <span :class="task.humanStatus.class">{{ task.humanStatus.label }}</span>
                        </div>
                    </div>
                    <div v-if="task.status === 'WAITING' || task.status === 'RUNNING'">
                        <div style="text-align: center; margin-bottom: 10px">
                            <i class="fa fa-cog fa-spin" style="font-size: 80px"></i>
                        </div>
                        <div style="text-align: center">
                            <span :class="task.humanStatus.class">{{ task.humanStatus.label }}</span>
                        </div>
                    </div>
                    <div v-if="task.status === 'FAILED' || task.status === 'ABORTED' || task.status === 'CANCELLED'">
                        <div style="text-align: center; margin-bottom: 10px">
                            <i class="fa fa-times-circle" :class="task.humanStatus.class" style="font-size: 80px"></i>
                        </div>
                        <div style="text-align: center">
                            <span :class="task.humanStatus.class">{{ task.humanStatus.label }}</span>
                        </div>
                    </div>
                </div>

                <div v-if="task.status === 'RUNNING'" style="margin-top: 5px">
                    <div v-for="item in progress">
                        <div class="progress" style="margin-bottom: 5px">
                            <div class="progress-bar progress-bar-striped active" :style="{ width: item.percentage + '%' }">
                                <span v-if="item.humanName">{{ item.humanName }} - </span>
                                <span>{{ item.percentage.toFixed(0) }}%</span>
                            </div>
                        </div>
                    </div>
                </div>

                <table class="table table-striped table-borderless" style="margin-top: 10px">
                    <tr v-for="log in task.logs">
                        <td>{{ log.message }}</td>
                        <td>{{ log.createdAt | time }}</td>
                    </tr>
                </table>

                <div class="tasks-bar-bottom" v-if="task.output">
                    <component :is="task.alias" :task="task" :done="done"></component>
                </div>

                <div style="margin-top: 20px; color: #999; font-size: 12px">
                    A tarefa continuará sua execução mesmo se essa janela for fechada. Você pode acompanhar no menu
                    <i class="fa fa-tasks x-navbar-icon" style="font-size: 20px; color: white; padding: 8px; background-color: #428bca"></i>
                </div>
            </div>
        </ui-modal>
    </div>
</template>
<script>
    const client = require('sci/helpers/queue-client')
    const clientWs = require('sci/helpers/queue-client-ws')
    const { gql } = require('@apollo/client/core')
    const helpers = require('./helpers')

    const TestV1 = require('./Outputs/TestV1.vue')
    const TestV2 = require('./Outputs/TestV2.vue')
    const ExportCustomersV1 = require('./Outputs/ExportCustomersV1.vue')
    const ExportPropertiesV1 = require('./Outputs/ExportPropertiesV1.vue')

    const progressNames = {
        'TestTaskV2': {
            'other': 'Teste'
        },
        'TestTaskV1': {}
    }

    export default {
        components: {
            TestV1,
            TestV2,
            ExportCustomersV1,
            ExportPropertiesV1
        },
        props: {},
        data () {
            return {
                task: null
            }
        },
        computed: {
            progress () {
                return this.task.progress.map((progress) => {
                    progress.humanName = null

                    if (progress.alias === '$default') {
                        return progress
                    }

                    if (progressNames[this.task.alias]) {
                        progress.humanName = progressNames[this.task.alias][progress.alias] || null
                    }

                    return progress
                })
            }
        },
        methods: {
            load(id) {
            },
            watch(id) {
                this.$refs.loadingModal.show()

                helpers.find(id).then((task) => {
                    this.$refs.loadingModal.hide()

                    this.task = task

                    this.$refs.modal.show()

                    this.subscribe()
                })
            },
            reload() {
                helpers.find(this.task.id).then((task) => {
                    this.task = task
                })
            },
            done() {
                this.$refs.modal.hide()
            },
            enqueue(task, version, input) {
                this.$refs.loadingModal.show()
                helpers.enqueue(task, version, input).then((enqueuedId) => {
                    return helpers.find(enqueuedId)
                }).then((task) => {
                    this.$refs.loadingModal.hide()

                    this.task = task

                    this.$refs.modal.show()

                    this.subscribe()
                })
            },
            subscribe() {
                const self = this
                if (this.task.status === 'WAITING' || this.task.status === 'RUNNING') {
                    this.$subscription = clientWs().subscribe({
                        query: gql`
                            subscription($id: Long!) {
                                result: watchTaskById(taskId: $id) {
                                    id
                                    name

                                    ... on TaskProgressUpdatedEvent {
                                        progress {
                                            alias
                                            percentage
                                        }
                                    }

                                    ... on TaskLogEvent {
                                        log {
                                            id
                                            level
                                            message
                                            createdAt
                                        }
                                    }
                                }
                            }
                        `,
                        variables: {
                            id: this.task.id
                        }
                    }).subscribe({
                        next(event) {
                            const data = event.data.result

                            switch (data.name) {
                                case "progress-updated":
                                    if (self.task.progress && self.task.progress.some(_ => _.alias === data.progress.alias)) {
                                        for (let p of self.task.progress) {
                                            if (p.alias === data.progress.alias) {
                                                p.percentage = data.progress.percentage
                                            }
                                        }
                                    } else {
                                        self.task.progress.push(data.progress)
                                    }
                                    break;
                                case "task-started":
                                    self.task.status = 'RUNNING';
                                    self.task.humanStatus = helpers.statusesNames[self.task.status]
                                    break;
                                case "task-finished":
                                    self.task.status = 'DONE';
                                    self.task.humanStatus = helpers.statusesNames[self.task.status]
                                    self.reload()
                                    break;
                                case "task-failed":
                                    self.task.status = 'FAILED';
                                    self.task.humanStatus = helpers.statusesNames[self.task.status]
                                    self.reload()
                                    break;
                                case "task-aborted":
                                    self.task.status = 'ABORTED';
                                    self.task.humanStatus = helpers.statusesNames[self.task.status]
                                    self.reload()
                                    break;
                                case "task-cancelled":
                                    self.task.status = 'CANCELLED';
                                    self.task.humanStatus = helpers.statusesNames[self.task.status]
                                    self.reload()
                                    break;
                                case "task-log":
                                    if (!self.task.logs.find(_ => _.id === data.log.id)) {
                                        self.task.logs.push(data.log)
                                    }
                                    break;
                            }
                        },
                        error(err) {
                            console.error({err})
                        },
                        complete() {
                            console.debug("complete")
                        }
                    })
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Modal.vue?400f2cab